import React from 'react';
import styles from './App.scss';
import GenericErrorBoundary from 'src/components/errorPages/GenericErrorBoundary';
import FixedStatusRoutes from '../routes/FixedStatusRoutes';
import StatusDataProvider from '../providers/StatusDataProvider';
const App = () => (<div className={styles.appContainer} data-public={true}>
    <GenericErrorBoundary>
      <StatusDataProvider>
        <div className={`${styles.routeContainer}`}>
          <FixedStatusRoutes />
        </div>
      </StatusDataProvider>
    </GenericErrorBoundary>
  </div>);
export default App;
